import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Wrap a state change in the View Transitions API when supported so
 * `::view-transition-old(root) / ::view-transition-new(root)` (see app.css)
 * gets a chance to cross-fade the two frames. On browsers without VT — and
 * on `prefers-reduced-motion: reduce` (handled inside the CSS) — the
 * callback runs immediately with no transition, which is the graceful
 * fallback we want.
 *
 * Also honors matching `view-transition-name` pairs already set on elements
 * (e.g., the trip card cover ↔ trip hero cover). Those pair through the
 * same transition frame without extra work.
 */
export function startViewTransition(cb: () => void | Promise<void>): void {
  const doc = typeof document !== "undefined" ? document : null;
  const supported =
    !!doc && typeof (doc as unknown as { startViewTransition?: unknown }).startViewTransition === "function";
  if (!supported) {
    void cb();
    return;
  }
  (doc as unknown as { startViewTransition: (cb: () => void | Promise<void>) => void }).startViewTransition(cb);
}
